// Security Baseline page copy, word for word from the DIGU Site Reference artifact.
export const BASELINE = {
  hero: {
    eyebrow: 'Security baseline v1.0',
    title: 'The control baseline we work to',
    lede: 'Thirty two numbered controls in five domains. Each one states what it is, how it is implemented, and the evidence that proves it. We publish it because a security team should be able to argue with it before they hire us. The controls are written against the risk, not the vendor, so they apply to every AI coding agent in your estate.',
  },

  distribution: {
    eyebrow: 'Distribution',
    title: 'Thirty two controls, five domains',
  },

  fourControls: {
    eyebrow: 'Four of the thirty two',
    title: 'Every control carries its evidence',
    columns: ['Control', 'Evidence handed over'],
    rows: [
      [
        {
          lead: 'The agent has its own identity',
          text: ', separate from any person, wherever it touches a system, issued through your identity provider with short lived credentials rather than stored keys.',
        },
        'Role definitions and an identity map',
      ],
      [
        { lead: 'Organization wide settings are enforced', text: ' and cannot be overridden locally.' },
        'Verification on three developer machines',
      ],
      [
        { lead: 'Automated workflows that outside input can trigger are reviewed and gated.', text: '' },
        'A workflow audit record',
      ],
      [
        { lead: 'A tested way exists to switch it off across the organization.', text: '' },
        'A kill switch drill record',
      ],
    ],
    closing:
      "Every control maps to the OWASP Top 10 for Agentic Applications, Anthropic's published security guidance, the NIST AI Risk Management Framework and ISO/IEC 42001 control objectives, so the work lands inside the programs you already run.",
  },

  notCertification: {
    title: 'What a control baseline is not',
    text: 'No one can certify you compliant for using AI. Certification is done by an accredited auditor. What we do is put the controls in place and hand you the evidence, so that when an auditor asks, the answer already exists. We are happy to work alongside yours.',
  },
};
